<template>
  <div class="w-full">
    <div class="w-full px-6">
      <div class="lg:flex flex-wrap">
        <div v-if="
          this.protect && !isInstructorsCourse || 
          course.isDraft && !isInstructorsCourse || 
          course.course_category.name === 'Tutorial' && user.role.name < 2 || 
          course.isProtected && user.role.name == 0 ||
          user.rolle != this.course.courseProfession && !superAdmin" 
        ></div>
        <!-- class="py-10 lg:w-2/3 w-full md:pr-6 sm:border-r border-gray-300" -->
        <div
          class="py-10 lg:w-3/3 w-full md:pr-6 "
          v-else-if="!this.protect && course || superAdmin"
        >
          <div class="flex justify-between items-center">
            <router-link to='/courses'>
              <div class="flex items-center">
                <div
                  class="mr-3 w-6 h-6 rounded-full text-gray-500 border border-gray-500 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-chevron-left"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <polyline points="15 6 9 12 15 18" />
                  </svg>
                </div>
                <h4 class="text-xl text-gray-900">Kursübersicht</h4>
               
              </div>
            </router-link>
            <router-link v-if="isInstructorsCourse || superAdmin" to='/instructor-courses'>
              <div class="flex items-center">
                <div
                  class="mr-3 w-6 h-6 rounded-full text-gray-500 border border-gray-500 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-chevron-left"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <polyline points="15 6 9 12 15 18" />
                  </svg>
                </div>
                <h4 class="text-xl text-gray-900">Meine Kurse</h4>
              </div>
            </router-link>

            <a class="level-item" aria-label="like">
                    <span class="icon is-small">
                      <b-tooltip label="Lerne jedes Modul einzeln">
                        <b-button
                          class="font-bold rounded-full"
                          type="is-primary is-light"
                          @click="navigateToCourse(course.id)"
                          @error="danger"
                          v-bind:class="{
                            'opacity-50': !edited,
                            'cursor-not-allowed': !edited,
                            'opacity-100': edited,
                            'hover:bg-green-600': edited,
                          }"
                          :disabled="!edited"
                        >
                          <span class="icon">
                            <i class="fas fa-compact"></i> <!-- Font Awesome icon -->
                          </span>
                          Compact
                        </b-button>
                      </b-tooltip>
                    </span>
                  </a>

            <!-- <section>
                 <b-tooltip label="Abbrechen und zurück">
                  
                  <b-button label="Abbrechen"
                      v-if="isInstructorsCourse || superAdmin"
                      v-on:click="cancle"
                      class="bg-red-500 text-white font-bold rounded-full"
                      @error="danger"
                      v-bind:class="{
                        'hover:bg-red-600': edited,
                      }"
                    >
                      Abbrechen
                    </b-button>
                 
            </b-tooltip>
          <b-tooltip label="Kurs speichern">
            <b-button label="Speichern"
              v-if="isInstructorsCourse || superAdmin"
             
              class="bg-green-500 text-white font-bold py-1 px-4 rounded-full"
              @click="saveChanges"
              @error="danger"
              v-bind:class="{
                'opacity-50': !edited,
                'cursor-not-allowed': !edited,
                'opacity-100': edited,
                'hover:bg-green-600': edited,
              }"
              :disabled="!edited"
            >
              Speichern
            </b-button>
            </b-tooltip>
          </section> -->
           <!-- <b-button @click="open = true">Show</b-button> -->
          </div>
          <br>
          <nav class="level is-mobile sm:py-0 py-2">
                <div class="level-left media-content">
                  <!-- <a class="level-item" aria-label="reply">
                    <b-tooltip label="Anfrag um den Kurs zu löschen">
                    <b-button
                        v-if="isInstructorsCourse || superAdmin"
                        v-on:click="cancle"
                        class="font-bold rounded-full"
                        type="is-danger"
                        outlined
                        @error="danger"
                        v-bind:class="{
                          'hover:bg-red-600': edited,
                        }"
                      >
                      <font-awesome-icon :icon="['fas', 'eraser']" /> Anfrage Kurs Löschen
                    </b-button>
                    </b-tooltip>
                  </a> -->
                  <a class="level-item" aria-label="like">
                    <span class="icon is-small">
                      <b-tooltip label="Kurs überprüfen">
                        <b-button label="Check-Modus"
                          v-if="isInstructorsCourse || superAdmin"
                          class="font-bold rounded-full"
                          type="is-primary is-light"
                          @click="checkChanges"
                          @error="danger"
                          v-bind:class="{
                            'opacity-50': !edited,
                            'cursor-not-allowed': !edited,
                            'opacity-100': edited,
                            'hover:bg-green-600': edited,
                          }"
                          :disabled="!edited"
                        />
                      </b-tooltip>
                    </span>
                  </a>
                  <a class="level-item" aria-label="retweet">
                      <span class="icon is-small">
                      <b-tooltip label="Alle Änderungen verwerfen und zurück zur Übersicht">
                      <b-button label="Abbrechen"
                          v-if="isInstructorsCourse || superAdmin"
                          v-on:click="cancle"
                          class="font-bold rounded-full"
                          type="is-warning"
                          @error="danger"
                          v-bind:class="{
                            'hover:bg-red-600': edited,
                          }"
                        />
                      </b-tooltip>
                    </span>
                  </a>
                  <!-- <a class="level-item" aria-label="like">
                    <span class="icon is-small">
                      <b-tooltip label="Co-Modus aktivieren / deaktivieren">
                        <b-button label="Co-Modus"
                          v-if="isInstructorsCourse || superAdmin"
                          class="font-bold rounded-full"
                          type="is-info"
                          outlined
                          @error="danger"
                          v-bind:class="{
                            'opacity-50': !edited,
                            'cursor-not-allowed': !edited,
                            'opacity-100': edited,
                            'hover:bg-green-600': edited,
                          }"
                          :disabled="!edited"
                        />
                      </b-tooltip>
                    </span>
                  </a> -->
                  <a class="level-item" aria-label="like">
                    <span class="icon is-small">
                      <b-tooltip label="Kurs speichern">
                        <b-button label="Speichern"
                          v-if="isInstructorsCourse || superAdmin"
                          class="font-bold rounded-full"
                          @click="saveChanges"
                          type="is-success"
                          @error="danger"
                          v-bind:class="{
                            'opacity-50': !edited,
                            'cursor-not-allowed': !edited,
                            'opacity-100': edited,
                            'hover:bg-green-600': edited,
                          }"
                          :disabled="!edited"
                        />
                      </b-tooltip>
                    </span>
                  </a>
                </div>
              </nav>
          
          <nav class="level is-mobile">
                <div class="level-left media-content">
            <section class="flex justify-between items-center">
              <div id="alfaview" v-if="course.isPublic && !course.isInviteCourse && !course.noLicence">
                <a
                href='https://app.alfaview.com/#/join/osz-oder-spree-digital/4219c529-01d5-5996-ae9a-208a4ed0ffbf/4wH6Xqd9PRYF8evOmNDoitpLPoXSen9q/v2'
                target="_blank">
                  <div v-if="!isInstructorsCourse" class="bg-purple-500 text-white font-bold py-1 px-4 rounded-full">Virtuellen Raum betreten</div>
                </a>
              </div>
              
              <div v-if="!course.isPublic && !course.isInviteCourse">
                <router-link :to="{ path: '/login' }">
                  <div v-if="!isInstructorsCourse && user.role.name <= 0" class="bg-indigo-500 text-white font-bold py-1 px-4 rounded-full">Kurs freischalten</div>
                </router-link>
              </div>

              <div v-if="course.isInvite">
                <router-link :to="{ path: '/invite/' + course.id, params: { id: course.id } }">
                  <div v-if="!isInstructorsCourse" class="bg-blue-500 text-white font-bold py-1 px-4 rounded-full">Einladungsanfrage verwalten</div>
                  <div v-else class="bg-blue-500 text-white font-bold py-1 px-4 rounded-full">Einladungsanfragen verwalten</div>
                </router-link>
              </div>
              <div v-else-if="course.isInviteCourse">
                <router-link :to="{ path: '/invite/' + course.id, params: { id: course.id } }">
                  <div v-if="!isInstructorsCourse" class="bg-green-500 text-white font-bold py-1 px-4 rounded-full">Einladungsanfrage verwalten</div>
                  <div v-else class="bg-green-500 text-white font-bold py-1 px-4 rounded-full">Einladungsanfragen verwalten</div>
                </router-link>  
              </div>
            </section>
            </div>
            </nav>
          <section class="block">
           <div class="block" v-if="isInstructorsCourse || superAdmin">
            <div class="box">
              <p><strong>Entwurf</strong></p>
                <div :class="{'active': this.course.isDraft}" class="toggle_container">
                  <span>
                  <ToggleDraftButton id="event_handle" v-on:change="triggerEventDraft" />
                  <font-awesome-icon
                  v-if="course.isDraft"
                  :icon="lockedIcon"
                  color="orange"
                  class="iconPanel"
                  />
                </span>
                </div>
            </div>
          </div>
            <!-- Toogle Geschützer Kurs  this.course.isPublic -->
<!--             <div v-if="isInstructorsCourse">
            <div class="box">
              <p><strong>Kurs für Zielgruppe</strong></p>
                <div :class="{'active': this.course.isProtected}" class="toggle_container2">
                  <span>
                  <ToggleProtectButton id="event_handle2" v-on:change="triggerEventProtect" />
                  <font-awesome-icon
                  v-if="course.isProtected"
                  :icon="lockedIcon"
                  color="red"
                  class="iconPanel"
                  />
                </span>
                </div>
            </div>
          </div> -->
          <div class="hidden sm:block">
<!-- Toogle Public Course  this.course.isPublic -->
          <div class="block" v-if="isInstructorsCourse || superAdmin">
            <div class="box">
              <p><strong>Öffentlicher Kurs</strong></p>
                <div :class="{'active': this.course.isPublic}" class="toggle_container3">
                  <span>
                  <TogglePublicButton id="event_handle3" v-on:change="triggerEvent" />
                  <font-awesome-icon
                    v-if="course.isPublic"
                    :icon="lockedIcon"
                    class="iconPanel"
                    />
                  </span>
                </div>
              </div>
          </div>
<!-- Toggle Invite Course -->
          <div class="block" v-if="isInstructorsCourse">
            <div :class="classObject">
              <div class="box">
                <p><strong>Rechtlich geschützter Kurs (Automatisch)</strong></p>
                <font-awesome-icon
                  v-if="course.noLicence"
                  :icon="lockedIcon"
                  color="blue"
                  class="iconPanel"
                  />
                  <div :class="{'active': this.course.isInvite}" class="toggle_container4">
                    <span>
                    <ToggleCCButton id="event_handle4" v-on:change="triggerEventCC" />
                    </span>
                  </div>
              </div>
            </div>
          </div>
         <!-- Toogle Geschützer Kurs  this.course.isPublic -->
           <div class="block" v-if="isInstructorsCourse">
            <div class="box">
              <span>
              <p><strong>Einladungskurs</strong></p>
              <font-awesome-icon
              v-if="course.isInviteCourse"
              :icon="lockedIcon"
              color="green"
              class="iconPanel"
              />
              </span>
                <div :class="{'active': this.course.isInviteCourse}" class="toggle_container5">
                  <span>
                  <ToggleInviteButton id="event_handle5" v-on:change="triggerEventInvite" />
                </span>
                </div>
            </div>
          </div>
        </div>
          </section>
          <div v-if="superAdmin" class="block sm:block">
            <section >
              <br>
              <div class="card">
             
                  <!-- <div class="block buttons">
                    <b-button type="is-danger" outlined @click="clickMe">Kursleiter ändern</b-button>
                    <b-button type="is-danger" outlined @click="clickMe">Kurs permanent löschen</b-button>
                  </div> -->
                
                <div class="card-content">
                  <b-message 
                  v-if="superAdmin && user.email !== course.instructor.email"
                    b-message type="is-danger" has-icon>
                    Sie sind Super Admin und nicht der Autor dieses Kurses! Ihnen stehen zusätzliche Funktionen zur Verfügung!    
                  </b-message>
                  <b-message 
                  v-if="superAdmin && user.email === course.instructor.email"
                    b-message type="is-success" has-icon>
                    Sie sind Super Admin und der Autor dieses Kurses! Ihnen stehen zusätzliche Funktionen zur Verfügung!   
                  </b-message>
                </div>
              <footer class="card-footer">
                <a class="card-footer-item" @click="clickMe">Kursleiter ändern</a>
                <a href="#" class="card-footer-item">Kurs löschen</a>
              </footer>
              </div>
            </section>
            <section v-if="isInstructorsCourse || superAdmin">
              <br>
              <b-message 
              title="Hinweis!" 
              type="is-warning" 
              has-icon
              size="is-medium"
              v-model="isActiveHint" 
              aria-close-label="Close message">
                Bitte als erstes eine Kategorie und eine Fähigkeit auswählen! Diese Zuordnungen können nur über den Systemadministrator neu konfiguriert werden!    
              </b-message>
              <br>

            </section>
          </div>
          <div class="block"
          v-if="this.userInvited"
                  
              
                  >
                  <section>
                    <b-message 
                    title="Hinweis!" 
                    type="is-success" 
                    has-icon
                    size="is-medium"
                    v-model="isActiveHintInvited" 
                    aria-close-label="Close message">
                    Du wurdest zu diesem Kurs eingeladen!  
                    </b-message>

                  </section>

                  <!-- <h3>Dieser Kurs ist ein Invite Kurs</h3> -->
                  </div>
                  <div class="block" v-else> 
                    <section 
                    v-if="this.course.isInvite || this.course.isInviteCourse"     
                    class="text-gray-800 text-5xl mt-2 mb-2 sm:text-center text-center"
                    v-bind:class="{
                    inviteCourse: active
                    }">
                      <b-message 
                      title="Hinweis!" 
                      type="is-info" 
                      has-icon
                      size="is-medium"
                      v-model="isActiveHintVr" 
                      aria-close-label="Close message">
                      Dieser Kurs ist ein Invite Kurs und kann nur mit Einladungen genutzt werden.  
                      </b-message>
                  </section> 
                </div>
    <div class="card-content py-10 md:py-10 w-full md:w-auto px-2 md:px-6">
      <div v-bind:class="{
                lockedCourse: !course.isPublic, publicCourse: course.isPublic
              }">
        <editable-text-field
            v-if="isInstructorsCourse || superAdmin"
            :showEdit="true"
            :text="course.name"
            :content.sync="course.name"
            @save="activateSave"
            class="font-bold text-gray-800 text-5xl mb-8 sm:text-left text-center"
          />
          <h3
            v-if="!isInstructorsCourse"
            class="font-bold text-gray-800 text-5xl mt-6 mb-8 sm:text-left text-center"
          >
         {{ course.name }}
          </h3>        
              <div class="columns">
                <div class="column"> 
                <h1 class="font-bold text-gray-900 text-3xl mb-6">Kurskategorie</h1>
                <div class="columns is-mobile">
                  <div class="column">
                    <select
                      name="categories"
                      id="categories"
                      v-if="superAdmin"
                      @change="changeCategory()"
                      class="focus:outline-none ml-0 md:mr-5 bg-blue-700 transition duration-150 ease-in-out hover:bg-blue-800 rounded text-white sm:px-3 px-8 py-2 text-xl sm:ml-0 mr-8"
                    >
                      <option
                      v-for="category in filteredCategories"
                    :key="course.name + category.id"
                
                      >
                      {{ category.name }}
                      </option>
                    </select> 
                    <button v-else
                    class="focus:outline-none ml-0 md:mr-5 bg-blue-700 transition duration-150 ease-in-out hover:bg-blue-800 rounded text-white sm:px-3 px-6 py-2 text-xl sm:ml-0 ml-8"
                  >
                  {{ course.course_category.name }}
                  </button>
                  </div>
                </div>
              </div>
                <!-- Power User can edit category -->                 
            

    <div class="column">  
  <!-- &#8727; Zeichen für * -->
      <h1 class="font-bold text-gray-900 text-3xl mb-6">Erfahrung</h1>
      <div class="columns is-mobile">
        <div class="column">
          <select
          name="skills"
          id="skills"
          v-if="superAdmin"
          @change="changeSkill()"
          class="focus:outline-none ml-0 md:mr-5 bg-blue-700 transition duration-150 ease-in-out hover:bg-blue-800 rounded text-white sm:px-3 px-8 py-2 text-xl sm:ml-0 mr-8"
          >
          <option
            v-for="skill in filteredSkills"
            :key="skill.name + skill.id"
          >
          {{ skill.name }}
          </option>
          </select>
        <button 
          v-else
          class="focus:outline-none ml-0 md:mr-5 bg-blue-700 transition duration-150 ease-in-out hover:bg-blue-800 rounded text-white sm:px-3 px-6 py-2 text-xl sm:ml-0 ml-8" 
        >
        {{ course.skill.name }}
        </button>
        </div>
   
        
      </div>
        </div>
      </div>
                <div>
                  <ul class="flex items-center mx-auto mt-6 flex flex-wrap">
                    <li
                      class="text-gray-600 flex items-center text-base px-6 sm:border-l border-gray-300"
                    >
                      <p>Kursdauer:&nbsp; </p>
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="flex-shrink-0 icon icon-tabler icon-tabler-clock"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" />
                          <circle cx="12" cy="12" r="9" />
                          <polyline points="12 7 12 12 15 15" />
                        </svg>
                        <!-- :text="course.duration" -->
                          <editable-text-field
                            v-if="isInstructorsCourse"
                            :content.sync="course.duration"
                            @save="activateSave"
                            class="text-gray-600 mb-2"
                          />
                          <b-field>
                            <b-tag class="ml-3" size="is-medium">{{ course.duration }} min</b-tag>
                          </b-field>
                    
                    </li>
                    <li
                      class="text-gray-600 flex items-center text-base px-6 sm:border-r sm:border-l border-gray-300 sm:py-0 py-2"
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="flex-shrink-0 icon icon-tabler icon-tabler-file-horizontal"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                      <path
                        d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                      />
                    </svg>
                    <b-field>
                    <b-tag class="ml-3" size="is-medium">{{ course.sections.length }} Kapitel</b-tag>
                  </b-field>
                  
                  </li>
 <!--                 <li
                      class="text-gray-600 flex items-center text-base px-6 sm:border-r sm:border-l border-gray-300 sm:py-0 py-2"
                    >
                    <font-awesome-icon :icon="['fas', 'book']" />
                    <p class="ml-3">{{JsonObjectA}} Kursmodule</p>
                  </li>  -->
                  
                </ul>
              </div>
<!--                <template v-if="isInstructorsCourse" >
                  <section class="flex items-center mx-auto mt-6 flex flex-wrap"> 
                      <b-field label="Mit welchen Tags soll das Kapitel gefunden werden?">
                          <b-taginput
                              class="taginput-sortable"
                              v-sortable="sortableOptions"
                              v-model="tags"
                              ellipsis
                              icon="label"
                              placeholder="Einen Tag hinzufügen">
                          </b-taginput>
                      </b-field>
                      <p class="content"><b>Tags:</b> {{ tags }}</p>
                  </section>
              </template> -->
        </div>
        <hr class="mt-8 mb-6 border-t border-gray-300" />
        <h4 class="text-gray-900 text-xl font-medium mb-6">Kursübersicht</h4>
        <editable-text-field
        id="nameField"
        v-if="isInstructorsCourse || superAdmin"
        :text="course.description"
        :content.sync="course.description"
        @save="activateSave"
        class="text-gray-600 mb-2"
        />
        <p v-if="!isInstructorsCourse" class="text-gray-600 mb-2">
          {{ course.description }}
        </p>
      </div> 
      <br>
          <div v-if="isInstructorsCourse || superAdmin">
<!--           <b-button
          v-if="isOpen === true"
            label="Kapitel Control Panel Ausschalten"
            size="is-medium"
            type="is-primary is-light"
            class="px-4 py-5 md:max-w-sm md:mr-5 mb-6"
            @click="isOpen = !isOpen" 
            aria-controls="contentIdForA11y2"
            />
            <b-button
            v-else
            label="Kapitel Control Panel Einschalten"
            size="is-medium"
            type="is-primary "
            class="px-4 py-5 md:max-w-sm md:mr-5 mb-6"
            @click="isOpen = !isOpen" 
            aria-controls="contentIdForA11y2"
            /> -->
<!--             <b-button
            label="Sortieren"
            size="is-medium"
            type="is-primary is-light"
            class="py-3"
             />  -->
          <b-collapse 
          aria-id="contentIdForA11y2"
          class="panel"
          v-model="isOpen"
          animation="slide">
            <div v-if="isInstructorsCourse || superAdmin" class="panel-block">
 <!--              <span>
            <b-button
              type="is-success"
              size="is-medium"
              rounded
              class="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full"
              v-on:click="createSection"
            >
            <font-awesome-icon :icon="['fas', 'circle-plus']" />
              Kapitel
            </b-button>
          </span> -->
          <b-button
            type="is-warning is-light"
            @click="selectedOptions = []"><font-awesome-icon :icon="['fas', 'eraser']" />
          </b-button>
           <span>
             <!-- <p class="content"><b>selected</b>: {{ selectedOptions }}</p> -->
             <b-dropdown
             :scrollable="isScrollable"
             :max-height="maxHeight"
             v-model="selectedOptions"
             aria-role="list"
             trap-focus
             class="dropdown is-up"
             >
            <template #trigger>
              <div
                v-for="(section, section_index) in course.sections"
                class="py-10  w-full md:pl-6 md:px-0 px-4"
                v-show="section_index < 1"
                :key="section.id"
                :id="section.name + section_index"
              >
                <b-button
                class="bg-green-500 hover:bg-green-600 text-white ml-5 font-bold px-4 rounded-full"
                type="is-primary"
                icon-right="menu-down">
                <div v-if="selectedOptions.length == 0"><font-awesome-icon :icon="['fas', 'puzzle-piece']" /><span>&nbsp;Contentmodule auswählen {{ selectedOptions.length }}</span></div>
                <div v-else>
                  <font-awesome-icon :icon="['fas', 'puzzle-piece']"/>
                  <span>&nbsp;{{ selectedOptions.name }}</span>
                </div>

              </b-button>
              
              <span v-if="selectedOptions.licence === false"><font-awesome-icon
                      :icon="lockedIcon"
                      color="blue"
                      class="px-2 mt-3"
                    /></span>
                  </div>
                 
            </template>
                 <b-dropdown-item custom aria-role="listitem">
                   <b-input 
                  v-model="searchTerm"
                  type="search"
                  placeholder="Suche nach Contentmodulen..." 
                  expanded 
                  icon="search"
                  icon-pack="fas"
                  />
                </b-dropdown-item>

                <!-- <b-dropdown-item v-for="menu of filteredData" :key="menu" custom aria-role="listitem">
                    <div class="media-content">
                            <h3>Content auswählen:</h3>
                        </div>
                        {{menu.name}}
                </b-dropdown-item> -->
                <b-dropdown-item
                    v-for="(menu, index) in filteredData"
                    :key="index"
                    :value="menu" aria-role="listitem"
                    >
                    <div class="box">
                      <div v-if="menu.licence === false" class="media-content"><font-awesome-icon
                        :icon="lockedIcon"
                        color="blue"
                        class="items-center"
                        /></div>
                        <div class="media">
                          <b-icon class="media-left" :icon="menu.icon"></b-icon>
                          
                          
                          <div class="media-content">
                            
                            <h3><strong>{{menu.name}}</strong></h3>
                              <p>{{ menu.description }}</p> 
                              <b-field>
                                <b-tag>{{ menu.module_category.name }}</b-tag>
                              </b-field>
                            <div v-for="media in menu.media" :key="media.id" class="mt-2">
                            
                              <b-tooltip 
                                type="is-light"
                                :triggers="['click']"
                                :auto-close="['outside', 'escape']">
                                <template v-slot:content>
                                    <b-icon icon="heart" type="is-danger"></b-icon>
                                    <b-icon icon="thumb-up" type="is-info"></b-icon>
                                    <b-icon icon="thumb-down" type="is-warning"></b-icon>
                                    <b-icon icon="emoticon-cool"></b-icon>
                                </template>
                                <b-button disabled>
                              
                                  <div
                                    v-if="media.mime == 'application/pdf'"
                                    class="flex items-center"
                                  >
                                    <!-- <img src="/assets/images/PDF_file_icon.png" /> -->
                                    <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                                    <a target="_blank">&nbsp;{{
                                      media.name 
                                    }}</a>
                                  </div>
                              <div class="" v-if="media.mime == 'video/mp4'">
                            
                                <a target="_blank">{{
                                  media.name
                                }}</a>
                              <!-- <b-tooltip position="is-bottom" multilined>
                                <b-button label="Preview" type="is-info is-light" />
                                <template v-slot:content>
                                  <video controls class="video-width">
                                    <source 
                                      :src="media.url" 
                                      :type="media.mime"/>
                                    Sorry, your browser doesn't support embedded videos.
                                    </video>
                                </template>
                              </b-tooltip> -->
                              </div>
                            </b-button>
                          </b-tooltip>
                          <b-tooltip position="is-bottom" multilined>
                                <b-button v-show="media.mime == 'video/mp4'" label="Preview" type="is-info is-light" />
                                <template v-slot:content>
                                  <div class="" v-if="media.mime == 'video/mp4'">
                                  <video 
                                  controls 
                                  class="video-width"
                                  >
                                    <source 
                                      :src="media.url" 
                                      :type="media.mime
                                      "/>
                                    Sorry, your browser doesn't support embedded videos.
                                    </video>
                                  </div>
                                 
                                </template>
                              </b-tooltip>
                            </div>
                        </div>
                        <!-- <b-button
                          label="Toggle"
                          type="is-primary"
                          @click="active = !active" /> -->
                       <!--  <div>
                          <b-button
                            label="Preview"
                            type="is-primary"
                            size="is-small"
                            @click="cardModal" />
                        </div>  -->
                        <!-- <b-button
                              label="Anzeigen"
                              type="is-primary"
                              @click="active = !active" /> -->
                      </div>
                    </div>
                </b-dropdown-item>
                <b-button
                  label="Auswahl aufheben"
                  type="is-warning is-light"
                  expanded
                  @click="selectedOptions = []" />
            </b-dropdown>
            
          </span>
           <!-- <p class="content"><b>selected</b>: {{ modules }}</p> -->
<!--            <span>
          <b-field>
          <div
              v-for="(section, section_index) in course.sections"
              v-show="section_index < 1"
              :key="section.id"
              :id="section.name + section_index"
            >
             <b-select
                  name="modules"
                  id="modules"
                  v-if="isInstructorsCourse"
                  class="ml-5 "
                  rounded
                  placeholder="Bitte ein Modul auswählen" expanded
                >
                  <option
                    v-for="mod in modulesNotInSection(section_index)"
                    :key="section_index + mod.id"
                    :value="mod.name"
                  >
                  <div v-if="mod.licence === false" class="media-content">
                    Keine CC-Lizenz |</div> {{ mod.name }}
                  </option>
                </b-select>
            </div>  
            </b-field> 
          </span>   -->

          <span>
          <div class="py-10 w-full md:pl-6 md:px-0 px-4" v-if="user.role.name > 0">
          <b-button
          type="is-success"
          size="is-medium"
          rounded
          @click="open = true"
          class="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full"
          >
          <font-awesome-icon :icon="['fas', 'book']" />
          Bibliothek anzeigen
          </b-button>
              <div class="sidebar">
             
                <b-sidebar
                  type="is-light"
                  :fullheight="fullheight"
                  :fullwidth="fullwidth"
                  :overlay="overlay"
                  :right="right"
                  v-model="open"
                >
                  <ModulesSection />
                </b-sidebar>
         
              </div>
            </div>
          </span>
<!--           <span>
            <b-button
            label="Schließen"
            size="is-medium"
            type="is-primary "
          
            @click="isOpen = !isOpen" 
            aria-controls="contentIdForA11y2"
            />
          </span> -->
          </div>
        </b-collapse>
        </div>
<!-- Auswahl der Module über eigenen Button -->
<!-- @click="isActive = !isActive" -->
            <div 
            class="py-2 w-full px-3 "
            
            >
            <!-- Contentmodule im Sidepanel anzeigen -->
<!-- Border at the end of section card border-b-4 border-gray-800 -->
            <div 
            v-for="(section, section_index) in course.sections"
              :key="section.id"
            :class="{ activeSection: isActive }"
            :id="'section-' + section.id"
            >
            
            <editable-text-field
            v-if="isInstructorsCourse || superAdmin"
            :showEdit="true"
            :text="course.sections[section_index].name"
            :content.sync="course.sections[section_index].name"
            @save="activateSave"
            class="card py-10 w-full my-8 px-6 text-gray-900 text-xl font-medium"
            />
            <div v-if="isInstructorsCourse || superAdmin" class="tile is-child box">
                
                <b-button size="is-small" @click="createBuildUrl(section.id)">QR Code erzeugen</b-button>
                <img v-bind:src="fullQRUrl" v-if="section.id === activeSectionId && fullQRUrl" alt="Kein QR-Code vorhanden">
                <!-- <p>{{fullQRUrl}}</p> -->
              </div>
              <br>
            <b-button
                v-if="isInstructorsCourse || superAdmin"
                type="is-danger"
                size="is-small"
                rounded
                :id="course.sections[section_index].id"
                class="bg-red-500 hover:bg-red-600 text-white ml-5 font-bold px-4 rounded-full"
                v-on:click="deleteSection(section_index)"
                >
                <font-awesome-icon :icon="['fas', 'trash']" />
                Kapitel {{ section_index + 1 }} löschen
              </b-button>
            
            <h4
            v-if="!isInstructorsCourse"
            class="card py-10 w-full my-8 px-6 text-gray-900 text-xl font-medium"
            >
             {{ section.name }}
          </h4>

            <b-collapse
              
              :id="section.name + section_index"
              animation="slide"
              :open="isOpenSection"
              class="card py-10 w-full my-8 px-6"
            >
            <template #trigger="props" >
            <!-- <hr class="my-8 border-t border-gray-300" /> -->
 
            
            <div class="flex items-center" aria-controls="contentIdForA11y3"
            :aria-expanded="props.open">
            <h5>Inhalt Kapitel {{ section_index + 1 }}</h5>
            
            <!--                 <select
              name="modules"
              id="modules"
              v-show="section_index < 1"
              v-if="isInstructorsCourse"
              class="ml-5"
              >
              <option
              v-for="mod in modulesNotInSection(section_index)"
              :key="section_index + mod.id"
              :selected="mod.id"
              :value="mod.name"
              >
              {{ mod.name }}
            </option>
          </select> -->
<!--           <b-button
          v-if="isInstructorsCourse && isOpen"
          type="is-success"
          size="is-medium"
          rounded
          class="bg-green-500 hover:bg-green-600 text-white ml-5 font-bold px-4 rounded-full"
          v-on:click="addModule(section_index)"
          >
          <font-awesome-icon :icon="['fas', 'circle-plus']" />
          Contentmodul hinzufügen
        </b-button> -->

              <button 
              class="card-header-icon" 
              aria-label="more options"      
              >
                <span >
                  <b-tooltip label="Kapitel aufklappen" dashed>
                    <i aria-hidden="true"><font-awesome-icon :icon="['fas', 'arrow-down']" /></i>
                  </b-tooltip>
                </span>
              </button>

            <!-- <b-button
              v-if="isInstructorsCourse"
              type="is-danger"
              size="is-small"
              rounded
              :id="course.sections[section_index].id"
              class="bg-red-500 hover:bg-red-600 text-white ml-5 font-bold px-4 rounded-full"
              v-on:click="deleteSection(section_index)"
              >
              <font-awesome-icon :icon="['fas', 'trash']" />
              Kapitel löschen
            </b-button> -->

    </div>
    
    <!--               <div class="flex items-center mt-2">
      <p class="text-gray-600 text-sm">3 Lectures</p>
                <span class="mx-2 rounded-full w-1 h-1 bg-gray-300"></span>
                <p class="text-gray-600 text-sm">2 Videos</p>
                <span class="mx-2 rounded-full w-1 h-1 bg-gray-300"></span>
                <p class="text-gray-600 text-sm">2 Assignments</p>
              </div> -->
  
              <editable-text-field
                v-if="isInstructorsCourse"
                :text="course.sections[section_index].description"
                :content.sync="course.sections[section_index].description"
                @save="activateSave"
                class="text-gray-600 mt-6 text-sm"
              />
           
              <p v-if="!isInstructorsCourse" class="text-gray-600 mt-3 text-sm">
                {{ section.description }}
              </p>
            </template>
              <div
                v-for="(mod, mod_index) in section.modules"
                :key="'mod_div' + mod.id + mod_index"
              >
                <div class="flex mt-6 justify-between items-center">
                  <div class="flex flex-wrap items-center">
                    <h5 class="text-gray-900 font-medium">
                      {{ section_index + 1 }}.{{ mod_index + 1 }}
                    </h5>
                    <!-- For Power User to change the title of the module -->
<!--                     <editable-text-field
                      v-if="isInstructorsCourse"
                      :text="
                        course.sections[section_index].modules[mod_index].name
                      "
                      :content.sync="
                        course.sections[section_index].modules[mod_index].name
                      "
                      @save="activateSave"
                      class="text-gray-900 font-medium ml-3"
                    />  -->
                    <h5 class="text-gray-900 font-medium ml-3">
                      {{ mod.name }}
                    </h5>
                    <div>
                    <section>
                        <b-field class="px-2">
                          <b-tooltip position="is-bottom" multilined>
                            <b-tag type="is-info is-light" rounded size="is-small">CC-Lizenz</b-tag>
                            <template v-slot:content>
                                <b>CC-Lizenzen:</b>
                                <div v-if="mod.CC.CC_0 === '0'">CC-0</div>
                                <div v-if="mod.CC.CC_BY === 'BY'">BY</div>
                                <div v-if="mod.CC.CC_NC === 'NC'">NC</div>
                                <div v-if="mod.CC.CC_ND === 'ND'">ND</div>
                                <div v-if="mod.CC.CC_SA === 'SA'">SA</div>
                            </template>
                        </b-tooltip>
                            
                        </b-field>
                    </section>
                  </div>
                  <div v-if="!mod.licence">
                    <section>
                        <b-field>
                          <b-tooltip position="is-bottom" multilined>
                            <b-tag type="is-danger is-light" rounded size="is-small">
                              <font-awesome-icon
                                :icon="lockedIcon"
                                color="blue"
                                class="items-center"
                              />
                              Content Dritter</b-tag>
                            <template v-slot:content>
                                <b>Content Dritter</b>, Leider haben wir keine Freigabe.
                            </template>
                        </b-tooltip>
                            
                        </b-field>
                    </section>
                  </div>
                  <div
                  class="container px-2 py-2"
                  v-if="mod.module_subcategory && isInstructorsCourse"
                  >
                  <b-field grouped>
                  <div v-for="module_subcategory in mod.module_subcategory" :key="module_subcategory.id" class="control mt-2">             
                      <span>                       
                          <b-tag rounded size="is-medium">{{ module_subcategory.key }}</b-tag>             
                      </span>
                    </div>
                  </b-field>
                  </div>
                  <div>
                    <b-button
                    v-if="isInstructorsCourse || superAdmin"
                    
                    rounded
                    size="is-small"
                    type="is-danger"
                    class="bg-red-500 hover:bg-red-600 text-white ml-5 font-bold px-4 rounded-full"
                    v-on:click="deleteModule(course.sections[section_index].id, mod.id)"
                    >
                    <font-awesome-icon :icon="['fas', 'trash']" />
                      Contentmodul entfernen
                    </b-button>
                    
                  </div>
             <!--        <input
                      type="file"
                      :id="section_index + '.' + mod_index"
                      v-on:click="addFile(section_index, mod_index)"
                      class="ml-6"
                      multiple
                    /> -->
                  </div>
<!-- open or close the module in section and module length -->
<!--                   <div data-menu class="cursor-pointer">
                     <div class="flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="Hide"
                        class="icon icon-tabler icon-tabler-chevron-up"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="#718096"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <polyline points="6 15 12 9 18 15" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="Show"
                        class="hidden icon icon-tabler icon-tabler-chevron-down"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="#718096"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                      <span class="ml-6 text-gray-600 text-sm">12:29</span>
                    </div> 
                  </div> -->
                </div>
              <!-- Power User can change the description of the module -->
<!--                  <editable-text-field
                  v-if="isInstructorsCourse"
                  :text="
                    course.sections[section_index].modules[mod_index]
                      .description
                  "
                  :content.sync="
                    course.sections[section_index].modules[mod_index]
                      .description
                  "
                  @save="activateSave"
                  class="text-gray-600 text-sm mt-4"
                />
                <p
                  v-if="!isInstructorsCourse"
                  class="text-gray-600 text-sm mt-4"
                >
                  {{ mod.description }}
                </p>  -->
                <p
                  class="text-gray-600 text-sm mt-4"
                >
                  {{ mod.description }}
                </p>
    
                <!-- course.users_permissions_users.some((p) => p.email) -->
                <!-- {{ userInvited }} {{ course.isInvite }} {{ course.users_permissions_users.some((p) => p.email === user.email) }} isInviteCourse: {{ course.isInviteCourse }} noLicence: {{ course.noLicence }} isInstructorsCourse: {{ isInstructorsCourse }}  -->
                <div v-if="!course.isPublic && user.role.name > 0 && !course.isInviteCourse || course.isPublic && user.role.name >= 0 || isInstructorsCourse">
                <div v-if="!course.isInvite && !course.isInviteCourse || isInstructorsCourse || course.users_permissions_users.some((p) => p.email === user.email) || !course.isPublic && user.role.name > 0 || course.isInviteCourse === !course.isInviteCourse">
                  
                  <div >
                    <div>
                <!--   {{course.isPublic}} {{isInstructorsCourse}} -->
                  <!-- {{!course.isPublic}} -->
                <div v-for="media in mod.media" :key="media.id" class="mt-2">
                  <div
                    v-if="media.mime == 'application/pdf'"
                    class="flex items-center"
                  >
                    <!-- <img src="/assets/images/PDF_file_icon.png" /> -->
                    <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name 
                    }}</a>
                  </div>
                  <div class="video" v-if="media.mime == 'video/mp4'">
                    <video controls class="video-width">
                    <source 
                      :src="media.url" 
                      :type="media.mime"/>
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                    <a :href="media.url" target="_blank">Alternativer Link: {{
                      media.name
                    }}</a>
                  </div>
                  <div v-if="media.mime == 'application/zip'">
                    <!-- <font-awesome-icon class="text-xl" :icon="['fa-solid', 'fa-file-zipper']" /> -->
                    <!-- <video :src="'//' + API_URL + media.url"></video> -->
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name
                    }}</a>
                  </div>
                  <div v-if="media.mime == 'text/html'">
                    <a :href="media.url" target="_blank"
                      >Die Seite öffnen <font-awesome-icon class="ml-3" :icon="['far', 'fa-file-pdf']" /></a
                    >
                  </div>
                  <div v-if="!media.url">media: {{ media }}</div>
                </div>
                <div>
                    <div v-for="(mod, mod_index) in section.modules" :key="'mod_div' + mod.id + mod_index">
                      <div v-if="mod.iFrame_URL">
                        <br>
                        <h1>Webinar</h1>
                        <div class="iframe-container">
                          <iframe :src="mod.iFrame_URL" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <!-- <a :href="mod.iFrame_URL" target="_blank">{{ mod.iFrame_URL }}</a> -->
                        <b-button
                          type="is-link is-light"
                          tag="a"
                          target="_blank"
                          :href="mod.iFrame_URL"
                          icon-left="github-circle"
                          >
                          In einem neuen Fenster öffnen
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=""><hr class="my-8" /></div>
        <b-button
        v-if="isInstructorsCourse && isOpen"
        type="is-success"
        size="is-medium"
        rounded
        class="bg-green-500 hover:bg-green-600 text-white ml-5 font-bold px-4 rounded-full"
        v-on:click="addModule(section_index)"
        >
        <font-awesome-icon :icon="['fas', 'circle-plus']" />
        Contentmodul hinzufügen
      </b-button>
      </b-collapse>
    </div>
      <!--  notification is-info -->
      <div v-if="isInstructorsCourse" class="card py-10 w-full my-8 px-6">
      <div class="container px-2 py-2">
            <b-button
              type="is-success"
              size="is-medium"
              rounded
              class="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full"
              v-on:click="createSection"
            >
            <font-awesome-icon :icon="['fas', 'circle-plus']" />
              Kapitel
            </b-button>
          </div>
      </div>
    </div>

<!--           // Statistic Placeholder
          <div class="py-10 lg:w-1/3 w-full md:pl-6">
            <h4 class="text-gray-900 text-xl font-medium mb-6">Statistics</h4>
            <div class="mb-6 flex items-center">
              <div>
                <h5 class="mb-3 text-green-500 font-light text-3xl">92%</h5>
                <p class="text-gray-900">Success Rate</p>
              </div>
              <div class="ml-16">
                <h5 class="mb-3 text-green-500 font-light text-3xl">16</h5>
                <p class="text-gray-900">Courses Taught</p>
              </div>
            </div>
          </div> -->

<!--           // Upcoming Assigments - Placeholder QuizAdacemy
          <hr class="my-8 border-t border-gray-300" />
          <div class="flex items-center justify-between mb-6">
            <h4 class="text-gray-900 text-xl font-medium">
              Upcoming Assignments
            </h4>
            <a class="color-blue text-sm font-bold cursor-pointer">View All</a>
          </div>
          <p class="text-gray-600 mb-6">09/02/20 - Applied UX Hueristics</p>
          <p class="text-gray-600 mb-6">09/02/20 - Applied UX Hueristics</p>
          <p class="text-gray-600">09/02/20 - Applied UX Hueristics</p> -->

<!--          // Resources - Placheolder Lehrmateriallien
            <div class="py-16">
            <div class="flex items-center justify-between mb-6">
              <h4 class="text-gray-900 text-xl font-medium">Resources</h4>
              <a class="color-blue text-sm font-bold cursor-pointer"
                >View All</a
              >
            </div>
            <div
              class="xl:w-full xl:mx-0 border-b border-gray-300 rounded h-12 mb-8"
            >
              <ul class="flex items-center xl:justify-between">
                <li
                  :class="{ 'bg-gray-100 text-blue-500': tab === 'Videos' }"
                  v-on:click="activeTab('Videos')"
                  class="text-sm text-gray-600 py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Videos
                </li>
                <li
                  :class="{ 'bg-gray-100 text-blue-500': tab === 'Slides' }"
                  v-on:click="activeTab('Slides')"
                  class="text-sm text-gray-600 py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Slides
                </li>
                <li
                  :class="{ 'bg-gray-100 text-blue-500': tab === 'Audio' }"
                  v-on:click="activeTab('Audio')"
                  class="text-sm text-gray-600 py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Audio Notes
                </li>
              </ul>
            </div>
            <div class="flex items-center mb-8 text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-movie"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <line x1="8" y1="4" x2="8" y2="20" />
                <line x1="16" y1="4" x2="16" y2="20" />
                <line x1="4" y1="8" x2="8" y2="8" />
                <line x1="4" y1="16" x2="8" y2="16" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="16" y1="8" x2="20" y2="8" />
                <line x1="16" y1="16" x2="20" y2="16" />
              </svg>
              <p class="ml-4">Norman & Nielson TED talk on UX.mkv</p>
            </div>
            <div class="flex items-center mb-8 text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-movie"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <line x1="8" y1="4" x2="8" y2="20" />
                <line x1="16" y1="4" x2="16" y2="20" />
                <line x1="4" y1="8" x2="8" y2="8" />
                <line x1="4" y1="16" x2="8" y2="16" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="16" y1="8" x2="20" y2="8" />
                <line x1="16" y1="16" x2="20" y2="16" />
              </svg>
              <p class="ml-4">Norman & Nielson TED talk on UX.mkv</p>
            </div>
            <div class="flex items-center mb-8 text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-movie"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <line x1="8" y1="4" x2="8" y2="20" />
                <line x1="16" y1="4" x2="16" y2="20" />
                <line x1="4" y1="8" x2="8" y2="8" />
                <line x1="4" y1="16" x2="8" y2="16" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="16" y1="8" x2="20" y2="8" />
                <line x1="16" y1="16" x2="20" y2="16" />
              </svg>
              <p class="ml-4">Norman & Nielson TED talk on UX.mkv</p>
            </div>
          </div> -->
          
          <!-- // Examen - Placeholder QuizAcademy
            <div class="flex items-center justify-between mb-6">
            <h4 class="text-gray-900 text-xl font-medium">Exams</h4>
            <a class="color-blue text-sm font-bold cursor-pointer">View All</a>
          </div>
          <p class="text-gray-600 mb-6">
            Exams have not yet been announced by your instructor, they will
            appear here once they are announced
          </p> -->
          <div class="tile is-4 is-vertical is-parent">
          <div class="tile is-child box">
              <p class="title">Quicks</p>
              <p>Scan den QR-Code und du wirst sofort zu diesem Kurs weitergeleitet.</p>
              <img v-bind:src="fullUrl" alt="Kein QR-Code vorhanden">
              <div class="field has-addons">

                  <!-- <div class="content has-text-centered" style="width:100%">
                    <strong class="text-xl text-gray-900 content has-text-centered">{{ course.courseCode }}</strong>
                  </div> -->
              
            </div>
          </div>

          <div v-show="!superAdmin" class="py-16" id="author">
            <h4 class="text-gray-900 text-xl font-medium mb-6">Kursleiter</h4>
            <div class="flex items-center justify-between">
              <div class="box flex items-center">
                <div class="h-8 w-8">
                  <img
                    src="https://tuk-cdn.s3.amazonaws.com/assets/components/avatars/a_4_2.png"
                    alt
                    class="h-full w-full rounded-full overflow-hidden shadow"
                  />
                </div>
                <div class="ml-2">
                  <h5 class="text-xs text-gray-800">{{ course.instructor.firstName }} {{ course.instructor.lastName }}</h5>
                  <p class="text-xs text-gray-800">{{ course.instructor.profession }}</p>
                </div>
              </div>
<!--               <button
                class="focus:outline-none ml-0 md:ml-5 bg-white transition duration-150 ease-in-out hover:bg-gray-100 rounded text-gray-800 px-3 md:px-6 py-2 text-sm border border-gray-800"
              >
                Follow
              </button> -->

            </div>
          </div>
          <b-button type="is-primary" outlined @click="backTop">Back to Top</b-button>
          </div> 
                     <!-- Instructor Placeholder for Component -->
                     <div> 
            
            <section v-show="superAdmin">
              <b-steps
                  :position="position"
                  :label-position="labelPosition"
                  :size="size"
                  vertical>
                  <b-step-item label="Alt" icon="account-key">
                    <b-message type="is-info">
                        Aktueller Autor für den Kurs. Der Autor kann diesen Kurs nicht weiter bearbeiten, sofern er nicht mehr als Autor eingetragen ist.
                    </b-message>
                  <div class="box flex items-center">
                    <div class="h-20 w-20">
                      <img
                        src="https://tuk-cdn.s3.amazonaws.com/assets/components/avatars/a_4_2.png"
                        alt
                        class="h-full w-full rounded-full overflow-hidden shadow"
                      />
                    </div>
                    <div class="ml-2">
                      <h5 class="text-xs text-gray-800">{{ course.instructor.firstName }} {{ course.instructor.lastName }}</h5>
                      <p class="text-xs text-gray-800">{{ course.instructor.profession }}</p>
                    </div>
                    <div class="px-2 py-2">
                    <b-tag type="is-success is-light">Aktueller Autor</b-tag>
                    </div>
                  </div>
                  </b-step-item>
                  <b-step-item label="Neu" icon="account">
                    <div class="box">
                    <!-- :is-row-checkable="(row) => row.id !== 3 && row.id !== 1" -->
              
                            <b-table
                            :data="users"
                            :columns="columns"
                            :checked-rows.sync="checkedRows"  
                            :hoverable="isHoverable"  
                            :is-row-checkable="(row) => row.id !== course.instructor.id"
                            checkable
                            checkbox-position="left"
                            checkbox-type="is-success"
                            >
                        
                            <b-table-column v-for="column in columns" :key="column.id" v-bind="column">
                                <template
                                    v-if="column.searchable && !column.numeric"
                                    #searchable="props">
                                    <b-input
                                        v-model="props.filters[props.column.field]"
                                        placeholder="Search..."
                                        value="Instructor"
                                        icon="magnify"
                                        size="is-small" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row[column.field] }}
                                </template>
                            </b-table-column>
                     
                    </b-table>
                   
                    <b-tab-item label="Checked rows">
                        <pre>{{ checkedRows }}</pre>
                    </b-tab-item>
                  </div>
                  
                  </b-step-item>
                  <b-step-item label="Bestätigen" icon="account-plus" disabled>
                    <div class="box">
                    <b-field v-show="checkedRows.length > 0" grouped group-multiline>
                      <b-button
                          label="Neuen Autor übernehmen"
                          type="is-success"
                          icon-left="close"
                          @click="changeAuthor"
                          class="field"
                        />
                      </b-field>
                      <br>
                      <div v-show="checkedRows.length > 0">
                        <b-message type="is-warning">
                          Nachdem Sie den neuen Autor übernommen haben, speichern Sie bitte den gesamten Kurs. Ansonsten werden die Änderungen verworfen und <strong>nicht</strong> gepseichert!
                        </b-message>
                      </div>
                      <b-message v-show="checkedRows.length == 0" type="is-warning">
                        Bitte wählen Sie einen Autor aus dem Schritt davor aus.
                    </b-message>
                  </div>
                     
                      <div class="box flex items-center">
                        <!-- <div class="box flex items-center">
                      <div class="h-20 w-20">
                        <img
                          src="https://tuk-cdn.s3.amazonaws.com/assets/components/avatars/a_4_2.png"
                          alt
                          class="h-full w-full rounded-full overflow-hidden shadow"
                        />
                      </div>
                      <div class="ml-2">
                        <h5 class="text-xs text-gray-800">{{ course.instructor.firstName }} {{ course.instructor.lastName }}</h5>
                        <p class="text-xs text-gray-800">{{ course.instructor.profession }}</p>
                      </div>
                      <div class="px-2 py-2">
                      <b-tag type="is-success is-light">Aktueller Autor</b-tag>
                      </div>
                    </div> -->
                    <div class="px-2 py-2">
                    <b-tag type="is-info is-light">Neuer Autor</b-tag>
                    </div>
                    <div v-show="checkedRows.length == 0">
                    <article class="media">
                      <figure class="media-left">
                          <p class="image is-64x64 px-10">
                              <b-skeleton circle width="64px" height="64px"></b-skeleton>
                          </p>
                      </figure>
                  </article>
                </div>
                    <div v-show="checkedRows.length > 0">
                    <!-- <div class="h-20 w-20">
                      <img
                        src="https://tuk-cdn.s3.amazonaws.com/assets/components/avatars/a_4_2.png"
                        alt
                        class="h-full w-full rounded-full overflow-hidden shadow"
                      />
                    </div> -->
                    <div class="ml-2">
                      <h5 class="text-xs text-gray-800"><pre>{{ checkedRows }}</pre></h5>
                      <p class="text-xs text-gray-800"></p>
                      <!-- <h5 class="text-xs text-gray-800">{{ checkedRows[0].firstName }} {{ checkedRows[0].lastName }}</h5>
                      <p class="text-xs text-gray-800">{{ checkedRows[0].email }}</p> -->
                    </div>
                  </div>
                  
                  </div>
                      <!-- {{ checkedRows }} -->
                  </b-step-item>
                </b-steps>
            </section>
           </div>


        </div>
        <div class="panel2 hidden sm:block">
            <b-button
            v-if="isInstructorsCourse && isOpen === false"
            label="Content"
            size="is-medium"
            type="is-primary "
            class="px-4 py-5 md:max-w-sm md:mr-5 mb-6"
            @click="isOpen = !isOpen" 
            aria-controls="contentIdForA11y2"
            />
            <b-button
            v-else-if="isInstructorsCourse"
            label="Schließen"
            size="is-medium"
            type="is-primary is-light"
            class="px-4 py-5 md:max-w-sm md:mr-5 mb-6"
            @click="isOpen = !isOpen" 
            aria-controls="contentIdForA11y2"
            />
          </div>
      </div>
    </div>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>education Brandenburg</strong> by <a href="https://jgthms.com">OSZ Palmnicken</a>
        </p>
      </div>
    </footer>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          The source code is licensed
          <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
          is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import gql from "graphql-tag";
// import { mapState } from "vuex";
import ModulesSection from './Modules.vue';
import TogglePublicButton from '../components/TogglePublicButton.vue'
import ToggleInviteButton from '../components/ToggleInviteButton.vue'
import ToggleCCButton from '../components/ToggleCCButton.vue'
import ToggleDraftButton from '../components/ToggleDraftButton.vue'


// import ToggleProtectButton from '../components/ToggleProtectButton.vue'

import Buefy from 'buefy';
import { ToastProgrammatic as Toast} from 'buefy';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf, faLock, faUserShield } from '@fortawesome/free-solid-svg-icons';

import EditableTextField from "../components/EditableTextField.vue";
import { mapState } from "vuex";

// import { GridLayout, GridItem } from 'vue-grid-layout';

import 'buefy/dist/buefy.css'

library.add(faFilePdf, faLock, faUserShield);

Vue.use(Buefy);

import Sortable from 'sortablejs'

const createSortable = (el, options, vnode) => {
        return Sortable.create(el, {
            ...options,
            onEnd: function (evt) {
                const data = vnode.componentInstance.$data.tags
                const item = data[evt.oldIndex]
                if (evt.newIndex > evt.oldIndex) {
                    for (let i = evt.oldIndex; i < evt.newIndex; i++) {
                        data[i] = data[i + 1]
                    }
                } else {
                    for (let i = evt.oldIndex; i > evt.newIndex; i--) {
                        data[i] = data[i - 1]
                    }
                }
                data[evt.newIndex] = item
                vnode.componentInstance.$emit('input', data)
                vnode.context.$buefy.toast.open(`Moved ${item} from row ${evt.oldIndex + 1} to ${evt.newIndex + 1}`)
            }
        })
    }

    /**
     * We add a new instance of Sortable when the element
     * is bound or updated, and destroy it when it's unbound.
     */
    const sortable = {
        name: 'sortable',
        bind(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable = createSortable(container, binding.value, vnode)
        },
        update(el, binding, vnode) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
            container._sortable = createSortable(container, binding.value, vnode)
        },
        unbind(el) {
            const container = el.querySelector('.taginput-container')
            container._sortable.destroy()
        }
    }

    const ModalForm = {
        props: ['email', 'password'],
        template: `
        <div class="modal">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">Modal title</p>
              <button class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
              <!-- Content ... -->
            </section>
            <footer class="modal-card-foot">
              <button class="button is-success">Save changes</button>
              <button class="button">Cancel</button>
            </footer>
          </div>
        </div>
        `
    }

export default {
  components: { 
    EditableTextField,  
    ModulesSection, 
    TogglePublicButton, 
    ToggleCCButton, 
    ToggleDraftButton, 
    ToggleInviteButton,
    // GridLayout,
    // GridItem
  },
  name: "HelloWorld",
  directives: { sortable },
  data: function () {
    return {
      sortableOptions: {
          chosenClass: 'is-primary',
          draggable: '.tag'
      },
      tags: [
      ],
      dataToBeWatched: '',
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      course: {},
      labelPosition: 'bottom',
      position: null,
      size: null,
      active: false,
      activeTooltip: true,
      isScrollable: true,
      maxHeight: 600,
      searchTerm: '',
      selectedOptions: [],
      isActive: false,
      isActiveHint: true,
      isActiveHintVr: true,
      isActiveHintInvited: true,
      activeSectionId: null, // ID of the active section
      modules: [],
      courseCategories: [],
      JsonObjectA: [],
      protect: false,
      skills: [],
      users:[],
      checkedRows: [],
      isUsersCourse: null,
      isInstructorsCourse: null,
      superAdmin: false,
      userInvited: false,
      edited: false,
      tab: "Videos",
      open: false,
      isOpen: false,
      isOpenSection: 0,
      danger: false,
      overlay: true,
      fullheight: true,
      fullwidth:true,
      lockedIcon: "fas fa-lock",
      right: true,
      p: "",
      p2: "",
      url: "",
      fullUrl: "",
      fullQRUrl: "",
      API_URL:
        process.env.NODE_ENV == "production"
          ? process.env.VUE_APP_STRAPI_API_URL
          : "localhost:1338",
      FRONTEND_URL:
        process.env.NODE_ENV == "production"
          ? "https://edubb.vercel.app"
          : "http://localhost:1338",
      currentMenu: { icon: 'account-group', text: 'Contentmodule' },
      menus: [
          { icon: 'account-group', text: 'People' },
          { icon: 'shopping-search', text: 'Orders' },
          { icon: 'credit-card-multiple', text: 'Payments' },
          { icon: 'dolly', text: 'Logistics' },
          { icon: 'clock-check', text: 'Jobs' },
          { icon: 'cart-arrow-right', text: 'Cart' },
          { icon: 'settings', text: 'Configuration' }
      ],
      columns: [
          {
              field: 'id',
              label: 'ID',
              width: '40',
              numeric: true,
          },
          {
              field: 'username',
              label: 'Username',
          },
          {
              field: 'firstName',
              label: 'Vorname',
          },
          {
              field: 'lastName',
              label: 'Nachname',
              searchable: true
          },
          {
              field: 'email',
              label: 'Email',
              searchable: true
          },
          {
              field: '',
              label: 'Einladung',
          },
          {
              field: 'rolle',
              label: 'Institut',
              centered: true
          },
          {
              field: "role.name",
              label: 'Rolle',
              centered: true,
              searchable: true
          }
      ]
    };
  },
  updated(){
    try{
        this.buildUrl()
        this.countlicence()
      }catch(e){
        console.log(e)
      }
  }, 
  methods: {
    navigateToCourse(courseId) {
    this.$router.push(`/courses/${courseId}/0/0`);
    },
    clickMe() {
        this.$buefy.notification.open('Kursleiter ändern')
        this.bottom = document.body.scrollHeight
          window.scrollTo(0, this.bottom);
    },
    backTop() {
        this.bottom = document.body.scrollHeight
          window.scrollTo(this.bottom, 150);
    },
    // https://qrcode.tec-it.com/API/QRCode?data=
    // https://chart.googleapis.com/chart?cht=qr&chs=
    // this.fullUrl = 'https://qrcode.tec-it.com/API/QRCode?data=' + 400 + 'x' + 400 + "&chl=" +  encodeURIComponent(this.p)
    buildUrl(){
      this.p = this.FRONTEND_URL + this.$route.path
      console.log(this.p)
      this.fullUrl = 'https://qrcode.tec-it.com/API/QRCode?data=' + encodeURIComponent(this.p)
    },

    createBuildUrl(sectionId){
      // Set the active section ID
      this.activeSectionId = sectionId;

      this.p2 = this.FRONTEND_URL + this.$route.path + '?section=' + sectionId
      console.log("CourseDetailsModule QR Code URL", this.p2)
      this.fullQRUrl = 'https://qrcode.tec-it.com/API/QRCode?data=' + encodeURIComponent(this.p2)
    },

    getQRCodeUrl(sectionId) {
      // Construct and return the URL for the QR code based on the section ID
      // Replace 'YOUR_BASE_URL' with the base URL of your QR code generator service
      return this.FRONTEND_URL + this.$route.path + '?section=' + sectionId;
    },

    cardModal() {
        this.$buefy.modal.open({
            parent: this,
            component: ModalForm,
            hasModalCard: true,
            customClass: 'custom-class custom-class-2',
            trapFocus: true
        })
    },
    async cancle(e){
      //this.$router.go(-1);
      e.preventDefault()
      try{
          this.$router.push("/instructor-courses");
          location.reload(this.$router.currentRoute);
      }catch(error){
          this.error = true
      }     
    },
     async triggerEvent(value) {
      try{
      this.active = value;
      if(value){
      this.course.isPublic = true
      console.log("Public activated")
      }else{
        this.course.isPublic = false
        console.log("Public deativated")
      }
      }catch(err){
        this.error = true
      }
      
    },
    changeAuthor() {
      try{
      this.edited = true;
     // console.log("changing Author...");
     // console.log("current Instructor", this.course.instructor)
     // console.log("new Instructor", this.checkedRows[0].email)
        const newInstructorMail = this.checkedRows[0].email;

      const newInstructor = this.users.find((instructor) => {
        return instructor.email === newInstructorMail;
      });

      this.course.instructor = newInstructor;
      //console.log("nnew instructor",  this.course.instructor);

      Toast.open({
            message: `Der neue Autor wurde übernommen. Bitte Speichern Sie den Kurs um die Änderung zu übernehmen.`,
            position: 'is-top',
            type: 'is-warning is-light'
         })

      }catch(error){
        console.log("Error Autor changes")
      }
    },
    setIsUsersCourse() {
      try{
      console.log("setUsersCourse Method", this.usersCourses)
      this.userIsNotInCourse()
      console.log("SUPERKRÄFTE", this.superAdmin)
      if (this.usersCourses) {
        console.log(
          "course data available – figuring out if this course is users course"
        );
       // console.log("course id", this.course.id);
        
         const usersCourse = this.usersCourses.find((userCourse) => {
          return userCourse.id == this.course.id;
        });

       //const usersCourse = this.course.id;
       // console.log("users Course", usersCourse)
        this.isUsersCourse = usersCourse ? true : false;

        
        if (usersCourse && this.user.role.name == 2 || this.course.instructor.email === this.user.email || this.superAdmin){
          this.isInstructorsCourse = true;
          console.log("section length", this.course.sections.length)
          for(var i = 0, len = this.course.sections.length; i <= len; i++){
            console.log("module length", this.course.sections[i].modules.length)
            if(this.course.sections.length == 1){
              this.isOpenSection = i - 1
            }else{

              this.isOpenSection = i
            }
          }
       
        }
        else{
          this.isInstructorsCourse = false;
        } 

        //initialise vue.cookie
        // this.$cookie.set("isUsersCourse", this.isUsersCourse);
        // this.$cookie.set("isInstructorsCourse", this.isInstructorsCourse);
        

        // console.log("is Police course:", this.isPolizeiCourse);
        // console.log("is Feuerwehr course:", this.isFeuerwehrCourse);

        // console.log("is users course:", this.isUsersCourse);
        // console.log("user is instructor:", this.isInstructorsCourse);
        // console.log("modules", this.modules);
      }
      }catch(error){
        console.log("Error setIsUsersCourse CourseDetails", error)
      }
    },
    // activateEdit(id) {
    //   const elements = document.getElementById(id);

    //   console.log("activateEdit", elements);

    //   for (let i = 0; i < elements.length; i++) {
    //     const element = elements[i];
    //     element.editing = true;
    //   }
    // },

    activateSave() {
      //console.log("something changed")
      this.edited = true;
      Toast.open({
            message: `Änderung erfolgreich`,
            position: 'is-top',
            type: 'is-success is-light'
         })
    },
    async saveChanges(e) {
      e.preventDefault()
      try{
        this.countlicence()
        //console.log("updated course", this.course);
        Toast.open({
            message: `Der Kurs wurde erfolgreich geändert!`,
            duration: 8000,
            progressBar: true,
            position: 'is-top-center',
            type: 'is-success',
            pauseOnHover: true
         })
        this.$store.dispatch("update", this.course);
        this.$router.push({path: "/newcoursechoice"});
        //this.$router.go(-1);
      }catch(error){
        console.log("error saveChanges courseDetails",error)
      }
    },

    async checkChanges(e){
      e.preventDefault()
      try{
        this.countlicence()
        this.$buefy.notification.open('Check durchgeführt!')
      }catch(e){
        console.log(e)
      }
    },

    async triggerEventCC(value) {
      try{
      this.active = value;
      if(value){
      this.course.isInvite = true
      this.isActiveHint = true
      this.course.isInviteCourse = true
      console.log("CC activated")
      this.active = true
      }else{
        this.course.isInvite = false
        console.log("CC deativated")
        this.active = false
        this.course.isInviteCourse = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    async triggerEventInvite(value) {
      try{
      this.active = value;
      if(value){
      this.course.isInviteCourse = true
      console.log("Invite activated")
      this.active = true
      }else{
        this.course.isInviteCourse = false
        console.log("Invite deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    async triggerEventProtect(value) {
      try{
      this.active = value;
      if(value){
      this.course.isProtected = true
      console.log("Protect activated")
      this.active = true
      }else{
        this.course.isProtected = false
        console.log("Protect deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },
    async triggerEventDraft(value) {
      try{
      this.active = value;
      if(value){
      this.course.isDraft = true
      console.log("Draft activated")
      this.active = true
      }else{
        this.course.isDraft = false
        console.log("Draft deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },

     noLicence(){
      this.course.noLicence = true
    }, 

    createSection() {
      this.edited = true;
      console.log("creating new section...");
      console.log("index", this.course.sections.length)
      this.course.sections.push({
        name: "Titel für Kapitel eingeben",
        description: "Beschreibung eingeben",
        index: this.course.sections.length,
        modules: [],
      });
      Toast.open({
            message: `Neues Kapitel für den Kurs erstellt!`,
            position: 'is-top',
            type: 'is-success is-light'
         })
         this.bottom = document.body.scrollHeight
          window.scrollTo(0, this.bottom);
    },
    // createModule(sectionIndex) {
    //   this.edited = true;
    //   console.log("creating new module...");

    //   this.course.sections[sectionIndex].modules.push({
    //     name: "New Module",
    //     description: "Description",
    //     index: this.course.sections[sectionIndex].modules.length,
    //   });
    // },

    deleteSection(sectionIndex){
      this.edited = true;
      console.log("Delete section...");
      console.log("sections", this.course.sections)
      console.log("current section", this.course.sections[sectionIndex])
      console.log("current section id", this.course.sections[sectionIndex].index)
      try{
          Toast.open({
          message: `Kapitel <b>` + this.course.sections[sectionIndex].name + `</b> wurde entfernt!`,
          position: 'is-top',
          type: 'is-warning is-light'
          })
          this.course.sections.splice(sectionIndex, 1)
          console.log("sections", this.course.sections)
          this.triggerEventCC(false)
                  //this.noLicence(false)
      }catch(e){
        console.log(e)
      }
    },


  countlicence(){
    this.edited = true;
    let response = this.course.sections
    console.log("res", response)
    
    var keyCountCourses = Object.keys(response).length
    console.log("keyCountCourses", keyCountCourses)
    var ObjectX = Object.keys(response)
    console.log("ObjectX", ObjectX)
    
    this.next = JSON.stringify(response)
    this.nextObject = response
    
    ObjectX.forEach((item, keyCountCourses) => {
        var ObjectModules = response[keyCountCourses].modules
        //var keyCountCourseModules = response[keyCountCourses].modules.length
        
    ObjectModules.forEach((item, index) => {
      //console.log(keyCountCourseModules)
            //console.log("userObj1 collection count", item)
            ObjectX.push({"id":keyCountCourses, "licence":this.nextObject[Object.keys(this.nextObject)[keyCountCourses]].modules[index].licence});
        })
        });
        //console.log("slice ObjectX", ObjectX.slice(keyCountCourses))
        this.JsonObjectA = ObjectX.slice(keyCountCourses)
        console.log("JsonObjectA",this.JsonObjectA)
        
        const data = JSON.stringify(this.JsonObjectA)

/*              const result = Object.keys(Object.assign({}, ...data))
        console.log(result)
        console.log(result.map(item => Object.keys(item)[0]));
        //const resultStr = JSON.stringify(result)
*/
        this.userObj1 = JSON.parse(data, (key, value) => {
          //console.log("value manifest object", key)
          if (value === false && this.user.role.name > 0){
            //console.log("licence position ist false", value)
            
              Toast.open({
                message: `Der Kurs enthält ein Modul ohne CC-Lizenz und wird somit automatisch zu einem Invite Kurs!`,
                duration: 4000,
                position: 'is-top',
                role: 'alert',
                type: 'is-danger is-light',
            })
            this.triggerEventCC(true)
            this.noLicence()

            //console.log("Tag Detail Collection", this.tag)
          }
          
/*               switch(key){
            case this.currentRepo:

              //console.log("-----> manifest Array", Object.values(this.manifestArray))
              //console.log(Object.values(this.manifestArray)[1])
              // Object.keys(obj)[0]
              break;
              default:
                
              } */
              return value
            })
              
    },

    modulesNotInSection(sectionIndex) {
      let modulesInSection = this.course.sections[sectionIndex].modules;
      let modulesNotInSection = [];

      console.log("modulesInCourse", JSON.stringify(modulesInSection))
      console.log("module length", this.modules.length)

      let inSection = false;
      for (let i = 0; i < this.modules.length; i++) {
        const mod = this.modules[i];
        inSection = false;

       
        if (!inSection || !mod.name) modulesNotInSection.push(mod);
      }

      return modulesNotInSection;
    },

    // Altes modulesNotInSection 
/*     modulesNotInSection(sectionIndex) {
      try{
      let modulesInSection = this.course.sections[sectionIndex].modules;
      let modulesNotInSection = [];

      let inSection = false;
      for (let i = 0; i < this.modules.length; i++) {
        const mod = this.modules[i];
        inSection = false;
       // console.log("mod licence", mod.licence)

        for (let j = 0; j < modulesInSection.length; j++) {
          const modInSection = modulesInSection[j];
          if (modInSection.name === mod.name) inSection = true;
        }
        if (!inSection) modulesNotInSection.push(mod);
      }
      return modulesNotInSection;
      }catch(error){
        console.log("Error modulesNotInSection CourseDetails", error)
      }
    }, */
    
    deleteModule(sectionIndex, modIndex){
      this.edited = true;
      try{
        var sectionId = 0
        var modId = 0
        let moduleDelete = []

        console.log("delete module...", modIndex);
        console.log("delete module in section", sectionIndex);
        console.log("course.sections", this.course.sections)
        
        for (let i = 0; i < this.course.sections.length; i++){
          const modSec = this.course.sections[i];
          const modSecArray = modSec.modules
          
          if(modSec.id === sectionIndex){
            sectionId = i
            //console.log("modSec", modSec)
          }

          for (let j = 0; j < modSecArray.length; j++){
            const secModules = modSecArray[j]
            //console.log("secModules", secModules)
            if(secModules.id == modIndex){
              //console.log("modIndex", modIndex)
              //console.log("secModules.id", secModules.id)
              modId = j
              //console.log("mod in section", secModules)
              //console.log("j",  j)
              //console.log("j",  modSec.modules[j])
              // console.log("section ID from loop", sectionId)
              // console.log("mod array ID from loop", modId)
              console.log("mod to delete", this.course.sections[sectionId].modules[modId])
              Toast.open({
              message: `Content <b>` + this.course.sections[sectionId].modules[modId].name + `</b> wurde entfernt!`,
              position: 'is-top',
              type: 'is-warning is-light'
              })
              this.course.sections[sectionId].modules.splice(modId,1)
              this.triggerEventCC(false)
            }
          }
        }
        
        return moduleDelete

        //this.triggerEventCC(false)
        
       //this.course.sections.splice(sec, 1)
    
        //this.course.sections[sectionIndex].modules.push(mod);
      }catch(e){
        console.log(e)
      }
    },

    addModule(sectionIndex) {
      this.edited = true;
      try{
        console.log("creating new module...");
        console.log("modules in section", this.course.sections[sectionIndex].modules.length);
        console.log("selectedOptions", this.selectedOptions)

        /* if we use b-field we need getElementByID  */
        // console.log("b-field getElementByID", document.getElementById("modules").value);
        // const modName = document.getElementById("modules").value;
        
        /* if we use b-dropdown we need getElementByID  */
        // console.log("moduleId", this.selectedOptions[0].id);
        //console.log("selectedOptions getElementByID", this.selectedOptions[0].name);
        const modName = this.selectedOptions.name;

        const modSectionName = this.course.sections[sectionIndex].name;
        // const modSectionId = this.course.sections[sectionIndex];
        
     /*    const mod = this.selectedOptions.find((mod) => {
          console.log("mod find", mod)
          //console.log("modId find", mod.id)
          //console.log("modIdentifier find", mod.identifier)
          //console.log("modName find", mod.name)
          //console.log("modName sections find", mod.sections.name)
  
          return mod.name == modName;
        }); */
        const mod = this.selectedOptions
        console.log("mod before licence", mod)
        console.log("mod licence", mod.licence)
  
         console.log("modSectionName", modSectionName)
        // console.log("modSection Id", JSON.stringify(modSectionId))
        // console.log("sectionIndex", sectionIndex)
  
        if (modSectionName){
          console.log("modSectionName", modSectionName)
          this.course.sections[sectionIndex].modules.push(mod);
          //console.log("mod push", this.course.sections[sectionIndex].modules.push(mod))
          console.log("sectionIndex", sectionIndex)
          console.log("modName", modName)
          console.log("modSectionName", modSectionName)
          
          Toast.open({
              message: `Das Modul <b>` + modName + `</b> wurde dem Kapitel <b>` + modSectionName + `</b> hinzugefügt`,
              position: 'is-top',
              duration: 8000,
              role: 'success',
              type: 'is-success is-light'
           })
           this.selectedOptions = []
        }else{
              Toast.open({
              message: `Es wurde kein Modul ausgewählt!`,
              position: 'is-top',
              duration: 8000,
              role: 'alert',
              type: 'is-danger is-light'
           })
        }
        //this.course.sections[sectionIndex].modules.push(mod);
      }catch(e){
        console.log(e)
      }
      
    },

/*     // Altes addModule
     addModule(sectionIndex) {
      this.edited = true;
      console.log("creating new module...");
      const modName = document.getElementById("modules").value;
      
      const mod = this.modules.find((mod) => {
        return mod.name == modName;
      });
      // console.log("mod Name", mod.name)
      // console.log("mod id", mod.id)
      // console.log("mod licence", mod.licence)

      if(mod.licence == false){
        Toast.open({
            message: `Dem Kurs wurde ein Modul ohne CC-Lizenz hinzugefügt`,
            duration: 8000,
            progressBar: true,
            position: 'is-top-left',
            role: 'alert',
            type: 'is-is-warning is-light',
            pauseOnHover: true
         })
      }else{
        console.log("Mod hat CC Lizenz")
      }
     // console.log("sectionIndex",sectionIndex)

      this.course.sections[sectionIndex].modules.push(mod);

/*       this.course.section = skill;
      console.log("nnew skill", this.course.skill.name); */
  // },  

    orderCourseCategories() {
      try{
      console.log("this.cour", this.courseCategories);
      if (this.course && this.courseCategories) {
        const category = this.courseCategories.find((category) => {
          return category.name === this.course.course_category.name;
        });
        console.log("cate", category);

        for (let i = 0; i < this.courseCategories.length; i++) {
          const category_i = this.courseCategories[i];
          if (category_i.name === category.name) {
            let temp = this.courseCategories[0];
            this.courseCategories[0] = category_i;

            for (let j = 1; j <= i; j++) {
              let temp2 = this.courseCategories[j];
              this.courseCategories[j] = temp;
              temp = temp2;
            }
          }
        }
      //  console.log("courseCat ordered", this.courseCategories);
      }
    }catch(error){
      console.log("Error orderCourseCategories CourseDetails")
    }
    },
    orderSkills() {
      try{
      if (this.course && this.skills) {
        const skill = this.skills.find((skill) => {
          return skill.name === this.course.skill.name;
        });
        console.log("skill", skill);

        for (let i = 0; i < this.skills.length; i++) {
          const skill_i = this.skills[i];
          if (skill_i.name === skill.name) {
            let temp = this.skills[0];
            this.skills[0] = skill_i;

            for (let j = 1; j <= i; j++) {
              let temp2 = this.skills[j];
              this.skills[j] = temp;
              temp = temp2;
            }
          }
        }
       // console.log("skills ordered", this.skills);
      }
    }catch(error){
      console.log("Error orderSkills CourseDetails")
    }
    },
    changeCategory() {
      try{
      this.edited = true;
      console.log("changing category...");
      const categoryName = document.getElementById("categories").value;
      const category = this.courseCategories.find((category) => {
        return category.name === categoryName;
      });
      console.log("category", category)
      this.course.course_category = category;
      console.log("nnew vategory", this.course);
      }catch(error){
        console.log("Error changeCategory CourseDetails")
      }
    },
    changeSkill() {
      try{
      this.edited = true;
      console.log("changing skill...");
      const skillName = document.getElementById("skills").value;
      const skill = this.skills.find((skill) => {
        return skill.name === skillName;
      });

      this.course.skill = skill;
      console.log("nnew skill", this.course.skill.name);
      }catch(error){
        console.log("Error changeSkill CourseDetails")
      }
    },
/*     addFile(sectionIndex, modIndex) {
       this.edited = true;
       console.log("adding file...");

       const id = sectionIndex + "." + modIndex;
       console.log("id", id);

      const fileSelector = document.getElementById(id);
      console.log("fileSelector", fileSelector);
       fileSelector.addEventListener("change", (event) => {
         const newFile = event.target.files[event.target.files.length - 1];
        console.log("newFile", newFile);

         this.course.sections[sectionIndex].modules[modIndex].media.push(
           newFile
         );
       });
     }, */
/*     activeTab(element) {
      if (element === "Videos") {
        this.tab = "Videos";
      } else if (element === "Slides") {
        this.tab = "Slides";
      } else if (element === "Audio") {
        this.tab = "Audio";
      }
    }, */
    userIsNotInCourse() {
        console.log("user_permissions_users", this.course.users_permissions_users.some((p) => p.email === this.user.email))
    if (this.course.users_permissions_users.some((p) => p.email === this.user.email)) {
        this.userInvited = true
        this.isActiveHint = false
        this.isActiveHintInvited = true
        console.log("user invited:", this.userInvited)
    }
    if(this.user.user_permissions.some((p) => p.key === "super_admin" )){
      console.log("Dieser User hat Super_admin Kräfte")
      this.superAdmin = true
    }
  },

  },
  mounted(){

    this.userIsNotInCourse()
    this.sortedData()
  },

  beforeUpdate(){
    console.log("mounted CourseDetails")
    const urlParams = new URLSearchParams(window.location.search);
   const sectionId = urlParams.get('section');

   console.log('Section ID from URL:', sectionId);
    
     // Get the section id from the URL

    // Scroll to the section specified in the URL parameter when the component is mounted
    if (sectionId) {
      const sectionElement = document.getElementById(`section-${sectionId}`);
      if (sectionElement) {
        console.log('Section element found:', sectionElement);
        sectionElement.scrollIntoView({ behavior: 'smooth' });
      } else {
      console.warn('Section element not found');
    }
    }else {
    console.warn('Section ID parameter not found in URL');
    }
    console.log("beforeMount isProtected CourseDetails", this.course.isProtected)
    if(!this.course.isInvite){
      this.course.noLicence = false
      this.isActiveHint = false
    }
    if(this.course.isProtected === true ){
      let user = localStorage.getItem('user')
      ? localStorage.getItem('user')
      : null;
      user = JSON.parse(user);
    
/* 
      console.log("Diese Seite ist nur für bestimmte Nuter und Geschützt", user)
      console.log("course courseProfession CourseDetails", this.course.courseProfession)
      console.log("course user_permissions CourseDetails", user.user_permissions.some((p) => p.key === user.rolle))
      console.log("es existiert keine Rolle und der Kurs ist geschützt für:", this.course.courseProfession)
      console.log("User Rolle courseDetails", user.rolle)
      console.log("Dieser Kurs gehört zur Gruppe:", this.course)
      console.log("instructor email", this.course.instructor.email)
      console.log("current user", user) */

      if(user === null)
      this.$router.push('/404')

      if(user.user_permissions.some((p) => p.key === "super_admin")){
        console.log("willkommen")
      }else if(this.course.instructor.email != user.email){
        // this.$router.push('/404')
      }else{
        console.log("Welcome")
      }

      if(user){
        console.log("user eingeloggt")
        console.log("user rolle", user.rolle)
        console.log("user role", user.user_permissions.some((p) => p.key === user.rolle))
        console.log("course Profession", this.course.courseProfession)
        if ((user.user_permissions.some((p) => p.key == user.rolle)) && user.rolle == this.course.courseProfession || this.superAdmin) {
          console.log("course courseProfession CourseDetails", this.course.courseProfession)
          console.log("course user_permissions CourseDetails", user.user_permissions.some((p) => p.key === user.rolle))
          this.protect = false
        }else{
          this.protect = true
        }
      }else{
        if(this.course){
          console.log("es existiert keine Rolle und der Kurs ist geschützt für:", this.course.courseProfession)
          this.protect = true
          // this.$router.push('/courses');
        }
      }
        if (!user && this.course.isProtected || user === null && this.course.isProtected)
        console.log("Dieser Kurs ist geschützt!")
      
    }
  },   
  computed: {
    ...mapState({
      courseCategories: "courseCategories",
      usersCourses: "usersCourses",
      JsonObjectA: "JsonObjectA"
    }),
    filteredCategories() {
      return this.courseCategories.filter(category => category.name !== 'Bitte auswählen:');
    },
    filteredSkills() {
    return this.skills.filter(skill => skill.name !== 'Bitte auswählen:');
    },
    filteredData() {
      return this.modules.filter((item) => item.name.toLowerCase().indexOf(this.searchTerm) >= 0);
    },
    sortedData() {
      let sortedData = this.modules
      
      sortedData.sort((a,b) => {
        let fa = a.name.toLowerCase(), fb = b.name.toLowerCase();
              if (fa < fb) {
                return -1
              }
              if (fa > fb) {
                return 1
              }
              return 0
      })
      return sortedData
    },

    didLoad: function () {
      // this is just a bool to load the data setting methods when page is called. ignore its value.
      console.log("loading page...");
      if (this.course === null){
        console.log("Kurs ist NULL")
        this.setCourseData();
      } 
      if (this.isUsersCourse === null){
        console.log("UserCourse ist Null")
        //this.userIsNotInCourse()
        this.setIsUsersCourse();
      } 
    //  console.log("course", this.course);
      return true;
    },
    classObject() {
    return {
      //active: this.noLicence,
      //active: this.course.isInvite,
      'inviteCourseDetected': this.noLicence,
    }
  }
  },
  apollo: {
    course: {
      query: gql`
        query ($id: ID!) {
          course(id: $id) {
            id
            name
            description
            duration
            isPublic
            isInvite
            isInviteCourse
            isProtected
            isDraft
            noLicence
            courseProfession
            courseCode
            users_permissions_users{
            id
            username
            email
            }
            course_category {
              id
              name
            }
            skill {
              id
              name
            }
            instructor {
                id
                firstName
                lastName
                email
                profession
              }
            sections {
              id
              name
              description
              modules {
                id
                name
                description
                licence
                iFrame_URL
                CC
                module_subcategory
                media {
                  id
                  name
                  mime
                  url
                }
              }
            }
            instructor {
              id
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id,
        };
      },
    },
    modules: {
      query: gql`
        query {
          modules (start: 50, limit: 100) {
            id
            identifier
            name
            description
            licence
            iFrame_URL
            CC
            module_category{
              id
              name
            }
            sections {
              id
              name
            }
            media {
              id
              name
              mime
              url
            }
          }
        }
      `,
    },
    sectionsId: {
      query: gql`
              query {
					sections{
            id
            name
          }
        }
        `,
    },
    courseCategories: {
      query: gql`
        query {
          courseCategories {
            id
            name
          }
        }
      `,
    },
    skills: {
      query: gql`
        query {
          skills {
            id
            name
          }
        }
      `,
    },
    users: {
        query: gql`
        query {
          users (where:{role: {name: "Instructor"}},
        ){
            id
            username
            firstName
            lastName
            email
            confirmed
            blocked
            rolle
            profession
            role{
                name
            }
          }
        }
        `,
        },
  },
  watch: {
    dataToBeWatched: function(val){
      if(val){
        console.log("something chaged")
      }
    },
    course: function () {
      try{ 
        this.setIsUsersCourse();
        this.orderCourseCategories();
        this.orderSkills();
        this.addModule();
      }catch(e){
        console.log("error course function watch")
      }
    },
    usersCourses: function () {
      try{
        this.setIsUsersCourse();
      }catch(e){
        console.log("error usersCourses function watch", e)
      }
    },
    courseCategories: function () {
      try{
        this.orderCourseCategories();
      }catch(e){
        console.log("error courseCategories function watch",e)
      }
    },
    skills: function () {
      try{
        this.orderSkills();
      }catch(e){
        console.log("error skills function watch",e)
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
@import url("https://unpkg.com/buefy/dist/buefy.min.css");

#sidebar{
 width: 400px;
} 
  /* enter transitions */
  .toast-enter-active {
    animation: wobble 0.5s ease;
  }
  .sidebar{
    width: 400px
  }
  .sidebar-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    // min-height: 100vh;
    .sidebar-layout {
        display: flex;
        flex-direction: row;
        min-height: 100%;
        // min-height: 100vh;
    }
}
  /* leave transitions */
  .toast-leave-to {
    opacity: 0;
    transform: translateY(-60px);
  }
  .toast-leave-active {
    transition: all 0.3s ease;
  }

body {
  font-family: "Lato", sans-serif;
}
.toggle__protect_button input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    width: 1px;
    height: 1px;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
.image {
  height: 200px;
}
.video {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.video-width {
  width: 100%;
}
.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.panel {
    background-color: #ffffff;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
    position:fixed;
    right:0px;
    bottom:10px;
    width:60em;
    z-index:100;
}
.panel2 {
    position:fixed;
    right:0px;
    bottom:10px;
    width:6.5em;
    z-index:100;
}
.lockedCourse {
    background-color: rgba(0, 0, 0, 0.05);
    display:inline-block;
    border-radius:6px;
    background: #BFCBD9;
    box-shadow: inset 0 0 1px #BFCBD9;
    position:relative;
    margin-left: 20px;
    width: 100%;
    transition: all .25s;
}
.publicCourse {
    display:inline-block;
    //border-radius:6px;
    // background: #adedcb;
    // box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.inviteCourse {
    display:inline-block;
    border-radius:6px;
    // background: #3838fab6;
    //box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.inviteCourseDetected {
  background-color: rgba(0, 0, 0, 0);
  pointer-events: none !important;
}
.protectedCourse {
    display:inline-block;
    border-radius:6px;
    // background: #f42d97a8;
    box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.activeSection {
  border: 1px solid black;
  border-radius:6px;
}
.iconPanel{
  margin-left: 30px;
}
.vue-grid-layout {
    background: #eee;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    background: #ccc;
    border: 1px solid black;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-grid-item .add {
    cursor: pointer;
}
.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}
@media (max-width: 700px) {
         .long {
             max-width: 100%;
             flex-basis: 100%;
         }
         .image {
             width: 100%;
             height: 100%;
         }
}

@media screen and (max-width: 1023px) {
  .b-sidebar {
        .sidebar-content {
            &.is-mini-mobile {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
@media screen and (min-width: 1024px) {
  .b-sidebar {
        .sidebar-content {
            &.is-mini {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}

/* a[href$=".pdf"] {
  background: url(/assets/images/PDF_file_icon.png) no-repeat left center;
  padding-left: 28px;
  border-bottom: none !important;
} */
</style>
